import PropTypes from 'prop-types';

export default function MetaLabel({ children, className }) {
    return (
        <h5 className={`esc-ii-uppercase esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-sm${className ? ' ' + className : ''}`}>
            {children}
        </h5>
    );
}

MetaLabel.propTypes = {
    className: PropTypes.string,
};

MetaLabel.displayName = 'MetaLabel';
